import storage from 'redux-persist/lib/storage'
import sessionStorage from 'redux-persist/lib/storage/session'

// Custom storage that checks remember me preference
const customStorage = {
  getItem: async (key: string) => {
    const rememberMe = window.localStorage.getItem('rememberMe') === 'true'
    if (rememberMe) {
      return storage.getItem(key)
    } else {
      return sessionStorage.getItem(key)
    }
  },
  setItem: async (key: string, value: string) => {
    const rememberMe = window.localStorage.getItem('rememberMe') === 'true'
    if (rememberMe) {
      return storage.setItem(key, value)
    } else {
      return sessionStorage.setItem(key, value)
    }
  },
  removeItem: async (key: string) => {
    // Remove from both storages
    await storage.removeItem(key)
    await sessionStorage.removeItem(key)
  }
}

const persistConfig = {
  key: 'app',
  storage: customStorage,
  whitelist: ['auth'] // Only auth will be persisted
}

export default persistConfig
